// import { Component } from '@angular/core';
// import { MatTabsModule } from '@angular/material/tabs';
// import { RpeNspMdlModule } from '../rpe-nsp-mdl.module';


// import { RpeNsm1Component } from '../rpe-nsm1/rpe-nsm1.component'
// import { RpeNsm2Component } from '../rpe-nsm2/rpe-nsm2.component';
// import { RpeNsp2p1Component } from '../rpe-nsp2p1/rpe-nsp2p1.component';
// import { RpeNst2t1Component } from '../rpe-nst2t1/rpe-nst2t1.component';
// import { RpeDva1Component } from '../rpe-dva1/rpe-dva1.component';

import { Component } from '@angular/core';
import { RpeNsm1Component } from '../rpe-nsm1/rpe-nsm1.component';
import { RpeNsm2Component } from '../rpe-nsm2/rpe-nsm2.component';
import { RpeNsp2p1Component } from '../rpe-nsp2p1/rpe-nsp2p1.component';
import { RpeNst2t1Component } from '../rpe-nst2t1/rpe-nst2t1.component';
import { RpeDva1Component } from '../rpe-dva1/rpe-dva1.component';
import { MatTabsModule } from '@angular/material/tabs';


@Component({
  standalone: true,
  selector: 'rpe-nstab',
  templateUrl: './rpe-nstab.component.html',
  styleUrl: './rpe-nstab.component.scss',
  imports: [
    RpeNsm1Component,
    RpeNsm2Component,
    RpeNsp2p1Component,
    RpeNst2t1Component,
    RpeDva1Component,
    // RpeNspMdlModule
    MatTabsModule, 

  ], // Import MatTabsModule

})
export class RpeNstabComponent {

}
